export default "__VITE_ASSET__MoJO4Fz3__"